import React, { useState } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { motion } from "framer-motion";
import { useStudentAuth } from "../../context/StudentAuthContext";
import logo from "../../assets/logo.png";

export default function StudentLogin() {
  const { login } = useStudentAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const [form, setForm] = useState({ email: "", password: "" });
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  async function handleSubmit(e) {
    e.preventDefault();
    setLoading(true);
    setError("");
    try {
      await login(form);
      const dest = location.state?.from?.pathname || "/student/dashboard";
      navigate(dest, { replace: true });
    } catch (err) {
      if (err.response?.data?.requiresVerification) {
        navigate("/student/verify-otp", {
          replace: true,
          state: { email: err.response.data.email || form.email, from: location.state?.from },
        });
        return;
      }
      setError(err.friendlyMessage || "Could not log you in.");
    } finally {
      setLoading(false);
    }
  }

  return (
    <div className="pm-auth-shell">
      <Link to="/" className="pm-auth-shell__back pm-btn pm-btn--ghost pm-btn--sm">
        ← Back to home
      </Link>
      <motion.div
        className="pm-auth-card"
        initial={{ opacity: 0, y: 18 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.4 }}
      >
        <Link to="/" className="pm-auth-brand">
          <img src={logo} alt="Positive Moves" className="pm-brand-logo" />
        </Link>
        <h1>Welcome back</h1>
        <p className="pm-auth-sub">Log in to manage your campus applications.</p>

        <form onSubmit={handleSubmit} className="pm-auth-form">
          <div className="pm-field">
            <label>Email address</label>
            <input type="email" required value={form.email} onChange={(e) => setForm({ ...form, email: e.target.value })} />
          </div>
          <div className="pm-field">
            <label>Password</label>
            <input type="password" required value={form.password} onChange={(e) => setForm({ ...form, password: e.target.value })} />

            <div style={{ textAlign: "right", marginTop: 6 }}>
              <Link to="/student/forgot-password">Forgot password?</Link>
            </div>
          </div>
          {error && <div className="pm-form-error">{error}</div>}
          <button className="pm-btn pm-btn--primary pm-btn--lg" disabled={loading} type="submit">
            {loading ? "Logging in…" : "Log in"}
          </button>
        </form>

        <p className="pm-auth-switch">
          New here? <Link to="/student/signup">Create an account</Link>
        </p>
      </motion.div>
    </div>
  );
}